import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './main.css'

import { isDevMode, isTestMode } from '@utils/env.ts'

import App from './App'
import mockRoutes from './mocking/mocking'

if (isDevMode || isTestMode) {
  await mockRoutes()
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App/>
  </StrictMode>
)
